<template>
  <div>
    <el-dialog title="新增SN" :append-to-body="true" :visible.sync="addDialogVisible" class="imgbox" width="30%" :before-close="resetForm" :close-on-click-modal='false'>
      <el-form label-width="100px" ref="ruleForm"  :rules="rules" :model="form">
        <el-form-item label="产品名称" prop="productKey">
          <el-select style="width:100%" v-model="form.productKey">
            <el-option
            v-for="item in options"
            :key="item.productId"
            :label="item.productName"
            :value="item.productKey">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建方式" :required="true">
          <el-radio-group v-model="radio" @change="changer">
            <el-radio :label="0">手动添加</el-radio>
            <el-radio :label="1">Excel导入</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="deviceSn" prop="deviceSn" v-if="!radio">
          <el-input v-model="form.deviceSn" maxlength="20" autocomplete="off" placeholder="请输入deviceSn"></el-input>
        </el-form-item>
        <el-form-item label="选择文件" prop="snUrl" v-else>
          <el-upload
            ref="upload"
            name="file"
            action="bb"
            :http-request="fileRequest"
            :before-upload="beforeUpload"
            :on-change="handleChange"
            accept=".xls,.xlsx"
            :file-list="fileList">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')" v-if="radio===0">确 定</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')" v-if="radio===1" :disabled="flag">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getPoductList, snAdd, snUpLoadFile } from '@/api/productControl'
import { v4 as uuidv4 } from 'uuid'
import { regx } from '@/assets/js/validator'
export default {
  props: {
    addDialogVisible: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    radio: { // 解决v-if判断下from表单错误提示一直存在问题
      handler (val) {
        if (val === 0) {
          this.$refs.ruleForm.clearValidate('snUrl')
        } else {
          this.$refs.ruleForm.clearValidate('deviceSn')
        }
      }
    }
  },
  data () {
    const fileNumber = (rule, value, callback) => {
      if (this.radio !== 0 && this.$refs.upload.uploadFiles.length === 0) {
        callback(new Error('请选择文件！'))
      } else {
        callback()
      }
    }
    return {
      options: [],
      flag: true,
      radio: 0,
      form: {
        deviceSn: ''
      },
      fileList: [],
      rules: {
        productKey: [
          { required: true, message: '请选择productKey', trigger: 'change' }
        ],
        deviceSn: [
          { required: true, validator: regx, trigger: 'blur' }
        ],
        snUrl: [
          { required: true, validator: fileNumber, trigger: 'change' }
        ]
      }
    }
  },
  created () {
    this.poductList()
  },
  methods: {
    changer (val) {
      console.log(val)
    },
    poductList () {
      getPoductList({}).then((res) => {
        this.options = res.data.data
      })
    },
    submitForm () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.radio === 0) {
            const params = Object.assign({}, this.form)
            snAdd(params).then((res) => {
              if (res.data.code === 200 || res.data.code === 0) {
                this.$message({
                  type: 'success',
                  message: '新增成功'
                })
                this.$emit('closeAddDialog', 1)
              }
            })
          } else {
            this.$message({
              type: 'success',
              message: '新增成功'
            })
            this.$emit('closeAddDialog', 1)
          }
        } else {
          return false
        }
      })
    },
    resetForm () {
      this.$emit('closeAddDialog')
    },
    handleChange (file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
    },
    beforeUpload (file) {
      /* const name = file.name
      const type = name.substring(name.lastIndexOf('.') + 1)
      if (type !== 'xsl') {
        this.$message.error('请上传json文件格式')
        return false
      } */
      if (file.size > 1024 * 1024) {
        this.$message.error('文件大小超过1M请重试')
        return false
      }
    },
    fileRequest (item) {
      const formData = new FormData()
      formData.append('file', item.file)
      formData.append('productKey', this.form.productKey)
      formData.append('id', uuidv4())
      formData.append('timestamp', Date.parse(new Date()))
      formData.append('version', '1.0')
      snUpLoadFile(formData)
        .then(res => {
          if (res.data.code === 200) {
            this.$message.success('上传文件成功')
            this.flag = false
          } else {
            this.$message.error(res.data.message)
            this.flag = true
          }
        })
    }
    /* // 上传成功的回调
    uploadSuccess (response, file, fileList) {
      this.$refs.ruleForm.validateField('firmwareUrl')
      if (response.code === 200) {
        console.log(response)
      } else {
        this.$message({
          type: 'error',
          message: '上传文件失败'
        })
        fileList.splice(0, 1)
      }
    },
    // 上传失败的回调
    uploadError (err, file, fileList) {
      this.$message.error(err)
    } */
  }
}
</script>

<style lang='less' scoped>

</style>
